import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_body" }
const _hoisted_3 = { class: "area_section" }
const _hoisted_4 = { class: "area_search" }
const _hoisted_5 = {
  key: 0,
  class: "area_search_checkbox"
}
const _hoisted_6 = { class: "checkbox_wrap" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "datepicker" }
const _hoisted_9 = { class: "datepicker" }
const _hoisted_10 = { class: "select-wrap" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "select-wrap"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "select-wrap" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "select-wrap"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "select-wrap" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 1,
  class: "select-wrap"
}
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "select-wrap" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 1,
  class: "select-wrap"
}
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "area_button" }
const _hoisted_39 = { class: "area_section" }
const _hoisted_40 = { class: "area_table" }
const _hoisted_41 = { class: "area_table_head" }
const _hoisted_42 = { class: "select-wrap" }
const _hoisted_43 = { class: "total_length" }
const _hoisted_44 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[84] || (_cache[84] = _createElementVNode("div", { class: "area_title" }, [
          _createElementVNode("p", null, "임시저장 목록")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              ($setup.state.dept === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: $setup.state.isChild === 1,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => {
                                                $setup.state.isChild = $setup.state.isChild === 1 ? 0 : 1;
                                                $setup.fnGetList(1);
                                            })
                          }, null, 8, _hoisted_7),
                          _cache[55] || (_cache[55] = _createElementVNode("em", null, null, -1)),
                          _cache[56] || (_cache[56] = _createElementVNode("span", null, "청소년팀만", -1))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _cache[58] || (_cache[58] = _createElementVNode("label", null, "작성일", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "startDate",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.startDate) = $event)),
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.changeStartDate && $setup.changeStartDate(...args)))
                    }, null, 544), [
                      [_vModelText, $setup.state.startDate]
                    ])
                  ]),
                  _cache[57] || (_cache[57] = _createElementVNode("span", null, "~", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "endDate",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.endDate) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.changeEndDate && $setup.changeEndDate(...args)))
                    }, null, 544), [
                      [_vModelText, $setup.state.endDate]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                        $setup.setDateToToday();
                                        $setup.fnGetList(1);
                                    })
                  }, " 오늘날짜 ")
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[64] || (_cache[64] = _createElementVNode("label", null, "검색조건1", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      name: "searchType",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.searchType1) = $event))
                    }, [
                      _cache[59] || (_cache[59] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchCondition, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key
                        }, _toDisplayString(item.name), 9, _hoisted_11))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, $setup.state.searchType1]
                    ])
                  ]),
                  (
                                        $setup.state.searchType1 !== 'state' &&
                                        $setup.state.searchType1 !== 'counselType' &&
                                        $setup.state.searchType1 !== 'result' &&
                                        $setup.state.searchType1 !== 'counselState'
                                    )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "searchText",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.searchText1) = $event)),
                        placeholder: "검색어를 입력해주세요.",
                        onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => ($setup.fnGetList(1)), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, $setup.state.searchText1]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        ($setup.state.searchType1 === 'state')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.searchText1) = $event)),
                              onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[60] || (_cache[60] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stateList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_13))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText1]
                            ])
                          : ($setup.state.searchType1 === 'counselState')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                name: "searchType",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.searchText1) = $event)),
                                onChange: _cache[12] || (_cache[12] = ($event: any) => ($setup.fnGetList(1)))
                              }, [
                                _cache[61] || (_cache[61] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.counselStateList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.key
                                  }, _toDisplayString(item.name), 9, _hoisted_14))
                                }), 256))
                              ], 544)), [
                                [_vModelSelect, $setup.state.searchText1]
                              ])
                            : ($setup.state.searchType1 === 'counselType')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.searchText1) = $event)),
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[62] || (_cache[62] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_15))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText1]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 3,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.state.searchText1) = $event)),
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[63] || (_cache[63] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_16))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText1]
                                ])
                      ]))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[70] || (_cache[70] = _createElementVNode("label", null, "검색조건2", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("select", {
                      name: "searchType",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.state.searchType2) = $event))
                    }, [
                      _cache[65] || (_cache[65] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchCondition, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key
                        }, _toDisplayString(item.name), 9, _hoisted_18))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, $setup.state.searchType2]
                    ])
                  ]),
                  (
                                        $setup.state.searchType2 !== 'state' &&
                                        $setup.state.searchType2 !== 'counselType' &&
                                        $setup.state.searchType2 !== 'result' &&
                                        $setup.state.searchType2 !== 'counselState'
                                    )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "searchText",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.state.searchText2) = $event)),
                        placeholder: "검색어를 입력해주세요.",
                        onKeyup: _cache[19] || (_cache[19] = _withKeys(($event: any) => ($setup.fnGetList(1)), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, $setup.state.searchText2]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        ($setup.state.searchType2 === 'state')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.state.searchText2) = $event)),
                              onChange: _cache[21] || (_cache[21] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[66] || (_cache[66] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stateList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_20))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText2]
                            ])
                          : ($setup.state.searchType2 === 'counselState')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                name: "searchType",
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.state.searchText2) = $event)),
                                onChange: _cache[23] || (_cache[23] = ($event: any) => ($setup.fnGetList(1)))
                              }, [
                                _cache[67] || (_cache[67] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.counselStateList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.key
                                  }, _toDisplayString(item.name), 9, _hoisted_21))
                                }), 256))
                              ], 544)), [
                                [_vModelSelect, $setup.state.searchText2]
                              ])
                            : ($setup.state.searchType2 === 'counselType')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.state.searchText2) = $event)),
                                  onChange: _cache[25] || (_cache[25] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[68] || (_cache[68] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_22))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText2]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 3,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.state.searchText2) = $event)),
                                  onChange: _cache[27] || (_cache[27] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[69] || (_cache[69] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_23))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText2]
                                ])
                      ]))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[76] || (_cache[76] = _createElementVNode("label", null, "검색조건3", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("select", {
                      name: "searchType",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.state.searchType3) = $event))
                    }, [
                      _cache[71] || (_cache[71] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchCondition, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key
                        }, _toDisplayString(item.name), 9, _hoisted_25))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, $setup.state.searchType3]
                    ])
                  ]),
                  (
                                        $setup.state.searchType3 !== 'state' &&
                                        $setup.state.searchType3 !== 'counselType' &&
                                        $setup.state.searchType3 !== 'result' &&
                                        $setup.state.searchType3 !== 'counselState'
                                    )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "searchText",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.state.searchText3) = $event)),
                        placeholder: "검색어를 입력해주세요.",
                        onKeyup: _cache[30] || (_cache[30] = _withKeys(($event: any) => ($setup.fnGetList(1)), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, $setup.state.searchText3]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        ($setup.state.searchType3 === 'state')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.state.searchText3) = $event)),
                              onChange: _cache[32] || (_cache[32] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[72] || (_cache[72] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stateList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_27))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText3]
                            ])
                          : ($setup.state.searchType3 === 'counselState')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                name: "searchType",
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.state.searchText3) = $event)),
                                onChange: _cache[34] || (_cache[34] = ($event: any) => ($setup.fnGetList(1)))
                              }, [
                                _cache[73] || (_cache[73] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.counselStateList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.key
                                  }, _toDisplayString(item.name), 9, _hoisted_28))
                                }), 256))
                              ], 544)), [
                                [_vModelSelect, $setup.state.searchText3]
                              ])
                            : ($setup.state.searchType3 === 'counselType')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.state.searchText3) = $event)),
                                  onChange: _cache[36] || (_cache[36] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[74] || (_cache[74] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_29))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText3]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 3,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.state.searchText3) = $event)),
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[75] || (_cache[75] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_30))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText3]
                                ])
                      ]))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[82] || (_cache[82] = _createElementVNode("label", null, "검색조건4", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("select", {
                      name: "searchType",
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.state.searchType4) = $event))
                    }, [
                      _cache[77] || (_cache[77] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchCondition, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key
                        }, _toDisplayString(item.name), 9, _hoisted_32))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, $setup.state.searchType4]
                    ])
                  ]),
                  (
                                        $setup.state.searchType4 !== 'state' &&
                                        $setup.state.searchType4 !== 'counselType' &&
                                        $setup.state.searchType4 !== 'result' &&
                                        $setup.state.searchType4 !== 'counselState'
                                    )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "searchText",
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.state.searchText4) = $event)),
                        placeholder: "검색어를 입력해주세요.",
                        onKeyup: _cache[41] || (_cache[41] = _withKeys(($event: any) => ($setup.fnGetList(1)), ["enter"]))
                      }, null, 544)), [
                        [_vModelText, $setup.state.searchText4]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        ($setup.state.searchType4 === 'state')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              name: "searchType",
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.state.searchText4) = $event)),
                              onChange: _cache[43] || (_cache[43] = ($event: any) => ($setup.fnGetList(1)))
                            }, [
                              _cache[78] || (_cache[78] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stateList, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key
                                }, _toDisplayString(item.name), 9, _hoisted_34))
                              }), 256))
                            ], 544)), [
                              [_vModelSelect, $setup.state.searchText4]
                            ])
                          : ($setup.state.searchType4 === 'counselState')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                name: "searchType",
                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.state.searchText4) = $event)),
                                onChange: _cache[45] || (_cache[45] = ($event: any) => ($setup.fnGetList(1)))
                              }, [
                                _cache[79] || (_cache[79] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.counselStateList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.key
                                  }, _toDisplayString(item.name), 9, _hoisted_35))
                                }), 256))
                              ], 544)), [
                                [_vModelSelect, $setup.state.searchText4]
                              ])
                            : ($setup.state.searchType4 === 'counselType')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.state.searchText4) = $event)),
                                  onChange: _cache[47] || (_cache[47] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[80] || (_cache[80] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.counselTypeList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_36))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText4]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 3,
                                  name: "searchType",
                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.state.searchText4) = $event)),
                                  onChange: _cache[49] || (_cache[49] = ($event: any) => ($setup.fnGetList(1)))
                                }, [
                                  _cache[81] || (_cache[81] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultList, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key
                                    }, _toDisplayString(item.name), 9, _hoisted_37))
                                  }), 256))
                                ], 544)), [
                                  [_vModelSelect, $setup.state.searchText4]
                                ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[50] || (_cache[50] = ($event: any) => {
                                    $setup.reset();
                                    $setup.fnGetList(1);
                                })
                }, " 초기화 "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[51] || (_cache[51] = ($event: any) => ($setup.fnGetList(1)))
                }, "검색")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("select", {
                    name: "orderType",
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.state.order) = $event)),
                    onChange: _cache[53] || (_cache[53] = ($event: any) => ($setup.fnGetList(1)))
                  }, [...(_cache[83] || (_cache[83] = [
                    _createElementVNode("option", { value: "0" }, "최근순", -1),
                    _createElementVNode("option", { value: "1" }, "과거순", -1)
                  ]))], 544), [
                    [_vModelSelect, $setup.state.order]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageState.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_DataGrid, {
                  list: $setup.pageState.list,
                  columns: $setup.pageState.fields,
                  totalLength: $setup.pageState.length,
                  perPage: $setup.pageState.perPage,
                  cntPage: $setup.pageState.cntPage,
                  "current-page": $setup.pageState.currentPage,
                  isLoading: $setup.pageState.isLoading,
                  onOnRowClick: $setup.fnRowClick,
                  onOnPaging: $setup.fnGetList,
                  onOnNextPage: $setup.fnGoPage,
                  onOnPrevPage: $setup.fnGoPage,
                  onOnFirstPage: $setup.fnGoPage,
                  onOnLastPage: $setup.fnGoPage
                }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage"])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[54] || (_cache[54] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}